<template>
  <div id="footer_area" class="sku_footer container-fluid">
    <div
      class="row container sku_footer_bottom"
      style="border-top: 1px solid #e3e9f012; padding: 15px 0;"
    >
      <div class="col-md-6">
        <span><a href="https://fpt.com.vn">FPT Co</a> © Sang Kien 2020</span>
      </div>
      <div class="col-md-6" style="text-align: end;">
        <span>
          Powered by <a href="javascript:void(0)">akaDEV</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import * as CONFIG from "../../config/index";
export default {
  name: "Footer"
};
</script>
<style scoped>
.sku_footer .container {
  margin: auto;
}
.sku_footer .fa-circle {
  font-size: 6px;
}

.sku_footer .sku_footer_bottom {
  display: flex;
  align-items: center;
}
#contact_footer {
  margin-top: -80px;
}

#contact_support_footer {
  color: #e3e9f0;
  font-size: 14px;
}

.sku_footer {
  letter-spacing: 0.5px;
  background-color: #232937;
  /* padding-top: 50px; */
}

.sku_footer_bottom > div {
  padding: 0;
}

.sku_footer_bottom {
  margin-top: 30px;
}

.sku_footer .sku_footer_bottom,
.sku_footer .sku_footer_bottom span{
  color: #e3e9f0;
  font-size: 14px;
}

.sku_footer hr.hr_title {
  border-top: 4px solid #ed8652;
  width: 35px;
  margin: 15px 0;
}

.sku_footer ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sku_footer ul li {
  padding-bottom: 10px;
}

.sku_footer ul li a {
  font-size: 14px;
  font-weight: normal;
  color: #e3e9f0;
  padding: 6px 0px;
}

.sku_footer h3 {
  margin-top: 15px;
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  text-transform: uppercase;
}

.underline-a:hover {
  text-decoration: underline;
}

.underline-a.active {
  text-decoration: underline;
}

#copyright {
  background: #0c4da2;
  height: 30px;
  float: right;
  padding: 6px;
  margin-right: 0px;
  margin-top: -2px;
  font-size: 12.5px;
  color: white;
}

b,
strong {
  font-weight: 700;
}
.sku_footer a{
  color: #0aecf6;
}
@media (max-width: 576px),
(max-width: 767.98px)
{
  #contact_footer {
    margin-top: 0px;
  }
}

@media (max-width: 576px),
(max-width: 767.98px){
  .sku_footer_bottom > div{
    text-align: start !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue